import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md text-center space-y-6 animate-in fade-in">
        <div className="w-16 h-16 mx-auto rounded-full bg-muted flex items-center justify-center">
          <XCircle className="w-8 h-8 text-muted-foreground" />
        </div>
        <div>
          <h1 className="font-heading text-2xl font-medium mb-2">Payment cancelled</h1>
          <p className="text-muted-foreground text-sm">
            No charges were made. You can try again anytime.
          </p>
        </div>
        <div className="space-y-3">
          <Button
            data-testid="payment-cancel-retry-btn"
            onClick={() => navigate("/pricing")}
            className="w-full btn-omni bg-primary text-primary-foreground gap-2 rounded-full"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Pricing
          </Button>
          <Button
            variant="ghost"
            onClick={() => navigate("/chat")}
            className="w-full rounded-full text-muted-foreground"
          >
            Continue to Chat
          </Button>
        </div>
      </div>
    </div>
  );
}
